<div
    class="dialog-header py-3 px-4 flex items-center bg-[rgb(3,22,50)] text-gray-50 border-b border-white/10"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    <div class="font-bold text-lg">{{ 'codext.reActivateDialogTitle' | transloco }}</div>
</div>
<div mat-dialog-content class="bg-[rgb(6,44,82)] pt-4">
    <div class="flex flex-col gap-4">
        <mat-form-field
            subscriptSizing="dynamic"
            class="maintenance-field">
            <mat-label class="text-white">{{ 'codext.reActivateInitials' | transloco }}</mat-label>
            <input
                matInput
                [(ngModel)]="initials"
                maxlength="10"
                (keydown.enter)="initials && password && onConfirm()" />
        </mat-form-field>
        <mat-form-field
            subscriptSizing="dynamic"
            class="maintenance-field">
            <mat-label class="text-white">{{ 'codext.reActivatePassword' | transloco }}</mat-label>
            <input
                matInput
                type="password"
                [(ngModel)]="password"
                (keydown.enter)="initials && password && onConfirm()" />
        </mat-form-field>
    </div>
</div>
<mat-dialog-actions align="end" class="bg-[rgb(6,44,82)] p-4 gap-2">
    <button
        mat-stroked-button
        mat-dialog-close
        class="!text-gray-300 !border-gray-500 hover:!border-gray-300">
        {{ 'codext.reActivateCancel' | transloco }}
    </button>
    <button
        mat-stroked-button
        (click)="onConfirm()"
        [disabled]="!initials || !password"
        class="!text-[rgb(6,44,82)] !bg-[#1e96f7] !border-[#1e96f7] disabled:!opacity-40">
        {{ 'codext.reActivateConfirm' | transloco }}
    </button>
</mat-dialog-actions>
